import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class PreferencesConfirmedApiService {
  constructor(private apiService: ApiService) {}

  confirmJobPreferences(request: string): Observable<string> {
    return this.apiService.httpWrapper({
      method: 'POST',
      url: `/api/job-preferences/confirm`,
      body: request,
      authenticated: true
    });
  }
}
